import clsx from "clsx";
import "./ButtonV2.scss";
import { Spinner } from "@/icons";
import React, { ReactNode } from "react";

type ButtonVariant = "primary" | "secondary";

type ButtonProps = {
  children: ReactNode;
  variant?: ButtonVariant;
  disabled?: boolean;
  loading?: boolean;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button";
};

export const ButtonV2 = ({
  children,
  variant = "primary",
  disabled = false,
  loading = false,
  onClick,
  type = "button",
  ...props
}: ButtonProps) => {
  const baseClasses = clsx(
    "fs-7 md-fs-6 fw-semibold",
    "ui-button-v2",
    `ui-button-v2-${variant}`,
    {
      "ui-button-v2-disabled": disabled || loading,
    },
  );

  return (
    <button
      type={type}
      className={baseClasses}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {children}
      {loading && <Spinner height={16} />}
    </button>
  );
};
